import * as React from "react";
import { Button, Gray100 } from "@traceair/tds";
import { forceRenderStyles, style } from "typestyle";
import { msg } from "../../../utils";

interface ISuggestedFlightMarkerPopupContent {
  name: string;
  isInstalled: boolean;
  updatePopupLayout: () => void;
  closePopup: () => void;
  onInstallAction: () => void;
}

export default class SuggestedFlightMarkerPopupContent extends React.Component<ISuggestedFlightMarkerPopupContent> {
  public componentDidMount() {
    forceRenderStyles();
    this.props.updatePopupLayout();
  }

  public render() {
    const { name, isInstalled, closePopup, onInstallAction } = this.props;

    return (
      <div
        className={style({
          width: "244px",
        })}
      >
        <div
          className={style({
            padding: "8px 12px",
            minHeight: "40px",
            boxSizing: "border-box",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          })}
        >
          <span
            className={style({
              fontFamily: "Inter Variable",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "18px",
              padding: "0 20px",
              textAlign: "center",
            })}
          >
            <span>{name}, </span>
            <span className={style({ color: Gray100 })}>
              {isInstalled ? "Installed" : "Suggested"}
            </span>
          </span>
          <CloseIcon
            className={style({
              cursor: "pointer",
              position: "absolute",
              top: "8px",
              right: "12px",
            })}
            onClick={closePopup}
          />
        </div>
        <div
          className={style({
            display: "flex",
            flexDirection: "column",
            padding: "12px",
            $nest: {
              "&>*": {
                marginTop: "8px",
              },
              "&>*:first-child": {
                marginTop: "0px",
              },
            },
          })}
        >
          <Button
            type={isInstalled ? "danger" : "default"}
            style="primary"
            text={
              isInstalled
                ? msg("Mark Incomplete", "Mark Incomplete")
                : msg("Mark Complete", "Mark Complete")
            }
            onClick={onInstallAction}
          />
        </div>
      </div>
    );
  }
}

const CloseIcon = ({
  className,
  onClick,
}: {
  className: string;
  onClick: () => void;
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={[
        "M6.11612 7.88388C5.62796 7.39573 5.62796 6.60427 6.11612 6.11612C6.60427 5.62796 7.39573 5.62796",
        "7.88388 6.11612L12 10.2322L16.1161 6.11612C16.6043 5.62796 17.3957 5.62796 17.8839 6.11612C18.372",
        "6.60427 18.372 7.39573 17.8839 7.88388L13.7678 12L17.8839 16.1161C18.372 16.6043 18.372 17.3957",
        "17.8839 17.8839C17.3957 18.372 16.6043 18.372 16.1161 17.8839L12 13.7678L7.88388 17.8839C7.39573",
        "18.372 6.60427 18.372 6.11612 17.8839C5.62796 17.3957 5.62796 16.6043 6.11612 16.1161L10.2322",
        "12L6.11612 7.88388Z",
      ].join(" ")}
      fill=" black"
    />
  </svg>
);
